import api from "./axiosAPI";

export const trailersAPI = {
    getTrailers: (page = 1, pageSize = 10, query = { search: '', ordering: 'last_update', groupBy: null }) => {
        // build parameters
        const params = new URLSearchParams({
            ...query,
            page,
            page_size: pageSize,
        });

        return api.get(`trailers/?${params.toString()}`);
    },

    getTrailerForTerminal: (terminalName) => {
        const params = new URLSearchParams({
            terminal_name: terminalName,
        });
        return api.get(`trailers/get-by-terminal/?${params.toString()}`);
    },

    changeStatus: (trailerId, newStatus) => {
        // PATCH request to update trailer status
        // Arguments:
        // - trailerId: ID of the trailer to update
        // - newStatus: New status value to set
        const statusResponse = newStatus === true ? "activate" : "deactivate";
        return api.patch(`trailers/${trailerId}/change-status/`, { status: statusResponse });
    },

    patchNotes: (trailerId, notes) => {
        return api.patch(`trailers/${trailerId}/patch-notes/`, { notes });
    }
};